import { render, staticRenderFns } from "./GroceryCarouselSectionModule.vue?vue&type=template&id=7ae03000&"
import script from "./GroceryCarouselSectionModule.vue?vue&type=script&lang=js&"
export * from "./GroceryCarouselSectionModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports